const Logo = () => {

    return (
        <div className="logo-container" onClick={() => {window.location.replace("/")}}><span style={{color: "white"}}>studyspace</span><span style={{color: "rgb(158, 159, 255)"}}>.io</span></div>
    )

}

export default Logo;